var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIco3RdParty24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "incon_3rd_party24x24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globe",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27016",
    "data-name": "Group 27016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27015",
    "data-name": "Group 27015",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46991",
    "data-name": "Path 46991",
    d: "M185.434,362.786a.333.333,0,0,0-.256-.12h-4.033a.333.333,0,0,0-.328.394c.479,2.6,1.4,4.273,2.344,4.273s1.865-1.677,2.344-4.273A.333.333,0,0,0,185.434,362.786Z",
    transform: "translate(-175.162 -351.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46992",
    "data-name": "Path 46992",
    d: "M363.3,170.9a.333.333,0,0,0-.317-.232h-3.754a.334.334,0,0,0-.332.367c.077.766.116,1.54.116,2.3s-.039,1.534-.116,2.3a.334.334,0,0,0,.332.367h3.754a.333.333,0,0,0,.317-.232,7.987,7.987,0,0,0,0-4.87Z",
    transform: "translate(-347.68 -165.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46993",
    "data-name": "Path 46993",
    d: "M317.321,14.537a.333.333,0,0,0,.329.278h3.365a.333.333,0,0,0,.293-.493,8.066,8.066,0,0,0-4.717-3.832.333.333,0,0,0-.387.481A11.43,11.43,0,0,1,317.321,14.537Z",
    transform: "translate(-306.281 -10.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46994",
    "data-name": "Path 46994",
    d: "M175.544,170.667h-4.42a.333.333,0,0,0-.331.3,22.457,22.457,0,0,0,0,4.738.333.333,0,0,0,.331.3h4.42a.333.333,0,0,0,.331-.3,22.457,22.457,0,0,0,0-4.738A.333.333,0,0,0,175.544,170.667Z",
    transform: "translate(-165.334 -165.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46995",
    "data-name": "Path 46995",
    d: "M30.187,14.811h3.365a.333.333,0,0,0,.329-.278A11.43,11.43,0,0,1,35,10.968a.333.333,0,0,0-.387-.481,8.066,8.066,0,0,0-4.717,3.832.333.333,0,0,0,.293.493Z",
    transform: "translate(-28.921 -10.145)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46996",
    "data-name": "Path 46996",
    d: "M4.7,175.891a.333.333,0,0,0,.085-.257c-.077-.766-.116-1.54-.116-2.3s.039-1.534.116-2.3a.334.334,0,0,0-.332-.367H.7a.333.333,0,0,0-.317.232,7.987,7.987,0,0,0,0,4.87A.333.333,0,0,0,.7,176H4.451A.333.333,0,0,0,4.7,175.891Z",
    transform: "translate(0 -165.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46997",
    "data-name": "Path 46997",
    d: "M33.88,362.945a.333.333,0,0,0-.329-.278H30.187a.333.333,0,0,0-.293.493,8.066,8.066,0,0,0,4.717,3.832.324.324,0,0,0,.1.014.333.333,0,0,0,.291-.5A11.429,11.429,0,0,1,33.88,362.945Z",
    transform: "translate(-28.921 -351.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46998",
    "data-name": "Path 46998",
    d: "M321.014,362.667H317.65a.333.333,0,0,0-.329.278,11.43,11.43,0,0,1-1.118,3.565.333.333,0,0,0,.291.5.326.326,0,0,0,.1-.014,8.066,8.066,0,0,0,4.717-3.832.333.333,0,0,0-.293-.493Z",
    transform: "translate(-306.281 -351.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46999",
    "data-name": "Path 46999",
    d: "M180.89,4.547a.333.333,0,0,0,.256.12h4.033a.333.333,0,0,0,.328-.394c-.479-2.6-1.4-4.273-2.344-4.273s-1.865,1.677-2.344,4.273A.333.333,0,0,0,180.89,4.547Z",
    transform: "translate(-175.163)"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12073",
    "data-name": "Rectangle 12073",
    width: 24,
    height: 24,
    fill: "none"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIco3RdParty24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_3rd_party24x24.2037d7d2fdcbbd130a00a68d21a66592.svg";